import { createLink } from "@tanstack/react-router"

import { LinkButton } from "~/components/design-system/components"

/** An in-app link (router props) in the design system's link style. */
export const RouteLink = createLink(LinkButton)
